<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import Speedtest from "./Speedtest.svelte";
  let active = false;

  onMount(async () => {
    active = true;
  });
</script>

{#if active}
  <div
    class="container has-text-left "
    transition:fade={{ delay: 300, duration: 700 }}
  >
    <p class="title is-1 has-text-light is-family-primary">
      Lightning fast data!
    </p>
    <p class="subtitle is-2 has-text-light is-family-primary mb-6">
      Speed up your data flows with our Azure solutions
    </p>
    <Speedtest />
  </div>
{/if}
